import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import CenterOpenAdd from "./CenterOpenAdd";
import CenterOpenEdit from "./CenterOpenEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import LightbulbIcon from "@mui/icons-material/Lightbulb";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Purchase() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(-1);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popPhone, setPopPhone] = useState("Hello");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const title = "운영시간관리";
  const title_add = '운영시간추가';

  const open = Boolean(anchorEl);

  // 폼 데이타
  const [data, setData] = useState({
    sname: "",
    sphone: "",
  });

  const onHandleData = (e) => {
    setData((state) => {
      return { ...state, [e.target.name]: e.target.value };
    });
  };

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "yoil", headerName: "요일", width: 80, align: "center" },
    
    {
      width: 120,
      field: "open",
      headerName: "시작시간",
      align: "center",
    },
    {
      width : 120,
      field: "close",
      headerName: "종료시간",
      align: "center",
    },
    {
      field: "state",
      headerName: "상태",
      width: 80,
      align: "center",
      renderCell: (params) => {
        const color = params.row.state === "Y" ? "#3096F4" : "gray";
        return <LightbulbIcon sx={{ color: color }}></LightbulbIcon>;
      },
    },
    { field: "cname", headerName: "센터명", width: 200, align: "cname" },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];

  const onCloseAddPop = () => {
    setShowAdd(false);
    load_data();
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    load_data();
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 리스트
  const load_data = async () => {
    console.log("load_data");
    pr("tcid=" + tcid);
    let result = await axios.post(configState.api + "/gympass_admin/center_open", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
    });
    log(result.data);
    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {   
    if(login.mcd !=='' && login.level==='500') {
      load_data();
    }    
    if(login.mcd!=='' && tcid !== "" && ( login.level=='100' || login.level==='50')) {
      load_data();
    }    
  }, [login, tcid]);

  // 팝업처리
  const onPopoverOver = (event, message) => {
    setPopPhone(message);
    setAnchorEl(event.currentTarget);
  };

  const onPopoverOut = (event) => {
    setAnchorEl(null);
  };

  const onSearchClick = async () => {
    load_data();
  };

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>          

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            {title}
          </h3>

          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
            <Box display="flex" alignItems="center">
              <Box>
                <CenterSelect
                  login={login}
                  tcidParent={tcid}
                  setTcidParent={setTcid}
                />
              </Box>
              <Box>
                <Button
                  sx={{ mt:1, ml: 1, fontSize: 15 }}
                  variant="contained"
                  onClick={onSearchClick}
                  size="small"
                >
                  조회
                </Button>
              </Box>
            </Box>

            <Box sx={{ flexGrow: 1 }}></Box>

            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={onOpenAdd}
            >
              {title_add}
            </Button>
          </Box>

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 500px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params) => {
              setSeq(params.row.id);
              setShowEdit(true);
            }}
          />

          <Dialog
            open={showAdd}
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>{title_add}</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseAddPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <CenterOpenAdd
              tcidParent={tcid}
              login={login}
              onCloseAddPop={onCloseAddPop}
            ></CenterOpenAdd>
          </Dialog>

          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            fullWidth={true}
            maxWidth="sm"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>운영시간수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <CenterOpenEdit
              login={login}
              seq={seq}
              onClose={onCloseEditPop}
            ></CenterOpenEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default Purchase;
